var _circle, _circle2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#4755CE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1733_2829",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#EEEFF6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1733_2829)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.4546,
    y: 14.7907,
    width: 25.7143,
    height: 27,
    transform: "rotate(45 18.4546 14.7907)",
    fill: "#0A3C88"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4106,
    y: -3.85712,
    width: 29.222,
    height: 30.6831,
    transform: "rotate(45 11.4106 -3.85712)",
    fill: "#AF569C"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.5fd26a6078b0354b3f6018e2c811cff0.svg";
export { ForwardRef as ReactComponent };